// extracted by mini-css-extract-plugin
export var checkMarkIcon = "CheckMarkIcon-module__checkMarkIcon___0485A";